module.exports = __webpack_public_path__ + "static/img/20260520001.b918822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/20260520001.jpg
// module id = MRh9
// module chunks = 0